module.exports = __webpack_public_path__ + "static/media/Search-blue.32426f2b.svg";